<cdk-virtual-scroll-viewport [itemSize]="itemHeight" inViewport forceResize class="h100">
    <ng-container *cdkVirtualFor="let row of groupedByRow; templateCacheSize: 0">
        <ng-container *ngFor="let item of row">
            <ng-container *ngTemplateOutlet="template, context: { item: item }"></ng-container>
        </ng-container>
    </ng-container>
</cdk-virtual-scroll-viewport>
